module.exports = __webpack_public_path__ + "img/ltktopshared-4x.898234a.jpg";